import { formatToMMYY } from '@/src/common/utils/date'
import { TouchableOpacity, View, Text } from 'react-native'
import { formatCardNumber } from '@/src/common/utils/card'
import { DuplicateIcon } from '@/src/assets/icons/Duplicate'
import type { LegacyPaymentCard } from '@/src/app/main/(tabs)/card/card-management/virtual-card/highnote/useLegacyPaymentCard'
import { useMemo } from 'react'
import { copyToClipboard } from '@/src/common/utils/copyToClipboard'
import * as Sentry from '@sentry/react-native'
import { cardBackStyles } from '@/src/app/main/(tabs)/card/card-management/virtual-card/CardBack'

export function LegacyCardBack({ paymentCard }: { paymentCard: LegacyPaymentCard }) {
  const { number, cvv } = useMemo(
    () =>
      paymentCard?.restrictedDetails?.__typename === 'PaymentCardRestrictedDetails'
        ? {
            number: paymentCard.restrictedDetails.number
              ? formatCardNumber(paymentCard.restrictedDetails.number)
              : 'N/A',
            cvv: paymentCard.restrictedDetails.cvv ? paymentCard.restrictedDetails.cvv : 'N/A',
          }
        : { number: 'N/A', cvv: 'N/A' },
    [paymentCard],
  )

  const expirationDate = useMemo(
    () =>
      paymentCard?.expirationDate ? formatToMMYY(new Date(paymentCard.expirationDate)) : 'N/A',
    [paymentCard],
  )

  return (
    <View style={cardBackStyles.cardContent}>
      <View>
        <Text style={cardBackStyles.labelText}>Card Number</Text>

        <Sentry.Mask>
          <View style={cardBackStyles.duplicateContainer}>
            <Text style={cardBackStyles.cardInfoText}>{number}</Text>
            <TouchableOpacity onPress={() => void copyToClipboard('Card Number', number)}>
              <DuplicateIcon />
            </TouchableOpacity>
          </View>
        </Sentry.Mask>
      </View>
      <View style={cardBackStyles.expiryCvvContainer}>
        <View style={cardBackStyles.expiryContainer}>
          <Text style={cardBackStyles.labelText}>GOOD THRU</Text>
          <Sentry.Mask>
            <View style={cardBackStyles.duplicateContainer}>
              <Text style={cardBackStyles.cardInfoText}> {expirationDate} </Text>
              <TouchableOpacity
                onPress={() => void copyToClipboard('Expiration Date', expirationDate)}
              >
                <DuplicateIcon />
              </TouchableOpacity>
            </View>
          </Sentry.Mask>
        </View>
        <View style={cardBackStyles.cvvContainer}>
          <Text style={cardBackStyles.labelText}>CVV</Text>
          <Sentry.Mask>
            <View style={cardBackStyles.duplicateContainer}>
              <Text style={cardBackStyles.cardInfoText}>{cvv}</Text>
              <TouchableOpacity onPress={() => void copyToClipboard('CVV', cvv)}>
                <DuplicateIcon />
              </TouchableOpacity>
            </View>
          </Sentry.Mask>
        </View>
      </View>
    </View>
  )
}
